import React from 'react'

import {GetStaticPaths, GetStaticPathsResult, GetStaticProps} from 'next'

import SEO from 'components/elements/SEO'
import TemplateBlog from 'components/templates/TemplateBlog'
import blogModel from 'src/backend/models/Blog.model'
import {BLOG_PAGE_SIZE} from 'src/configs/constants'
import {TPageComponent} from 'src/types'
import {TPost} from 'src/types/blog'

interface IBlogPageProps {
	count: number
	posts: TPost[]
}

const BlogPage: TPageComponent<IBlogPageProps> = ({posts, count}) => {
	return (
		<>
			<SEO
				keywords="paystub.org blog"
				title="Paystub, Paycheck, and Invoice Blog - Paystub.org"
				description="On the Paystub.org blog, you will find detailed guides and instructions on how to generate different paystubs, paychecks, financial forms, and invoices."
			/>
			<TemplateBlog {...{posts, count}} />
		</>
	)
}

BlogPage.displayName = 'Blog'

export const getStaticProps: GetStaticProps<IBlogPageProps> = async ({params}) => {
	try {
		const page = +(params?.page as string) || 1
		const data = await blogModel.get({page, pageSize: BLOG_PAGE_SIZE})
		return {
			props: {...data},
			revalidate: 60 * 60 * 24,
		}
	} catch {
		return {
			notFound: true,
		}
	}
}

export const getBlogPaths = async () => {
	const {count} = await blogModel.get({})
	const pagesCount = Math.ceil(count / BLOG_PAGE_SIZE)

	return new Array(pagesCount).fill('').map((_, idx) => {
		const pageNumber = idx + 1
		return `/blog/${pageNumber}`
	})
}

export const getStaticPaths: GetStaticPaths = async () => {
	const paths: GetStaticPathsResult['paths'] = await getBlogPaths()
	return {
		paths,
		fallback: 'blocking',
	}
}

export default BlogPage
